export * from './cookieConsent.data'
